var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7502 2.75C14.2564 2.75 14.6668 3.16041 14.6668 3.66667V5.5H19.2502C19.7564 5.5 20.1668 5.91041 20.1668 6.41667V18.3333C20.1668 18.8396 19.7564 19.25 19.2502 19.25H2.75016C2.24391 19.25 1.8335 18.8396 1.8335 18.3333V6.41667C1.8335 5.91041 2.24391 5.5 2.75016 5.5H7.3335V3.66667C7.3335 3.16041 7.74391 2.75 8.25016 2.75H13.7502ZM7.3335 7.33333H5.50016V17.4167H7.3335V7.33333ZM16.5002 7.33333H14.6668V17.4167H16.5002V7.33333ZM12.8335 4.58333H9.16683V5.5H12.8335V4.58333Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.945bfff26029bd2e22361e721596e422.svg";
export { ForwardRef as ReactComponent };